import AccountModel                   from '@models/account/AccountModel';
import AccountSubscriptionPriceModel  from '@models/account/AccountSubscriptionPriceModel';
import AccountSubscriptionStatusModel from '@models/account/AccountSubscriptionStatusModel';
import SubscriptionModel              from '@models/account/SubscriptionModel';
import SubscriptionPeriodModel        from '@models/account/SubscriptionPeriodModel';
import doc                            from '@widesk-core/decorators/doc';
import model                          from '@widesk-core/decorators/model';
import AccountServiceModel            from '@/models/AccountServiceModel';
import TimestampAble                  from '@widesk-core/models/traits/TimestampAble';
import Blamable                       from '@/models/traits/Blamable';

@model.urnResource('account_subscription')
@doc.path('/account_subscriptions/{?id}')
export default class AccountSubscriptionModel extends Blamable(TimestampAble(AccountServiceModel)) {
	private declare _tsFilters: {
		'account': id;
		'accountSubscriptionConfigs': id;
		'accountSubscriptionPrice': id;
		'accountSubscriptionStatus': id;
		'accountSubscriptionStatus.reference': Account_AccountSubscriptionStatusReference;
		'accountSubscriptionStatusHistories': id;
		'end[after]': string;
		'end[before]': string;
		'end[strictly_after]': string;
		'end[strictly_before]': string;
		'invoices': id;
		'paymentProviderSubscriptionId': string;
		'start[after]': string;
		'start[before]': string;
		'start[strictly_after]': string;
		'start[strictly_before]': string;
		'subscription': id;
		'subscriptionPeriod': id;
	};

	private declare _tsSorts: {
		'account.name': string;
		'id': string;
		'subscription.label': string;
	};

	@doc.model(AccountModel) declare account: AccountModel;
	@doc.model(AccountSubscriptionPriceModel) declare accountSubscriptionPrice: AccountSubscriptionPriceModel;
	@doc.model(AccountSubscriptionStatusModel) declare accountSubscriptionStatus: AccountSubscriptionStatusModel;
	@doc.date declare end: Dayjs;
	@doc.string declare paymentProviderSubscriptionId: string;
	@doc.date declare start: Dayjs;
	@doc.model(SubscriptionModel) declare subscription: SubscriptionModel;
	@doc.model(SubscriptionPeriodModel) declare subscriptionPeriod: SubscriptionPeriodModel;

	@doc.number declare unpaidAmount: number;
	@doc.string declare unpaidCurrency: string;
	@doc.string declare unpaidInvoiceId: string;
	@doc.boolean declare unpaidRequiresAction: boolean;
	@doc.date declare unpaidSince: Dayjs;

	public get hasPaymentProviderSubscription() {
		return !!this.paymentProviderSubscriptionId;
	}

	public get hasUnpaidInvoice() {
		return !!this.unpaidInvoiceId;
	}
}
